// extracted by mini-css-extract-plugin
export default {"month":"vp_w2FCT","months":"vp_zZkRm","today":"vp_uBqD1","selected":"vp_bx9Cf","disabled":"vp_hiAz_","chevron":"vp_piY5J"};